import { CLEAR_SYSTEM_NOTIFICATION } from '../../../../actions';

export default function clearSystemNotification() {
  return { type: CLEAR_SYSTEM_NOTIFICATION };
}
